// ProjectDetails.jsx
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import Work_ValeHRP from "./Projects/Vale-HRP/ValeHRP";
import Work_FiAR from "./Projects/FiAR/FiAR";
import Work_ValePreOp from "./Projects/Vale-PreOp/ValePreOp";
import Work_CertiFire  from "./Projects/CertiFire/CertiFire";
import Work_HoistingRigging from "./Projects/Hoisting-Rigging/HoistingRigging";
import Work_MotorControl from "./Projects/Motor-Control/MotorControl";
import Work_norcatLockTag from "./Projects/NORCAT-Lock-Tag/NORCATLockTag";
import Work_OntarioMineRescue from "./Projects/Ontario-Mine-Rescue/OntarioMineRescue";
import Work_OPGIncidentCommand from "./Projects/OPG-Incident-Command/OPGIncidentCommand";
import Work_SNCAS from "./Projects/Science-North-CAS/SNCAS";
import Work_SNNEX from "./Projects/Science-North-NEX/SNNEX";
import Work_NXR from "./Projects/nxr/NXR";
import Work_IndustrialHazardRecognitionProgram from "./Projects/Industrial-Hazard-Recognition-Program/IndustrialHazardRecognitionProgram";
import Work_AgnicoEagleExperience from "./Projects/Agnico-Eagle-Experience/AgnicoEagleExperience";
import Work_NORCATMineExperience from "./Projects/NORCAT-Mine-Experience/NORCATMineExperience";


// Ensure you add all project views here for slug
const projectViews = {
  "industrial-hazard-recognition-program": Work_IndustrialHazardRecognitionProgram,
  "agnico-eagle-experience": Work_AgnicoEagleExperience,
  "vale-hrp": Work_ValeHRP,
  "fiar": Work_FiAR,
  "vale-preop" : Work_ValePreOp,
  "certifire" : Work_CertiFire,
  "hoisting-rigging" : Work_HoistingRigging,
  "norcat-lock-tag" : Work_norcatLockTag,
  "opg-sim" : Work_OPGIncidentCommand,
  "sn-nex" : Work_SNNEX,
  "sn-cas" : Work_SNCAS,
  "motor-control" : Work_MotorControl,
  "ontario-mine-rescue" : Work_OntarioMineRescue,
  "norcat-nxr" : Work_NXR,
  "norcat-mine-experience": Work_NORCATMineExperience
};

export default function ProjectDetails() {
  const { slug } = useParams();

  const View = projectViews[slug];

  useEffect(() => {
    document.body.classList.add("project-detail-page-view");

    return () => {
      document.body.classList.remove("project-detail-page-view");
    };
  }, []);

  if (!View) return <div>Project data not found.</div>;

  return (
    <div className="work-detail-page">
      <View />
    </div>
  );
}
